// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1,.cls-2{isolation:isolate}.cls-2,.cls-3{mix-blend-mode:hard-light}.cls-4{fill:#9f2300}.cls-5{fill:#f8c91c}.cls-6{fill:#f59d23}.cls-7{fill:#494949}", ""]);
// Exports
module.exports = exports;
